<script>
    import Axios from 'axios'
    import config from '../../../libs/config.js';
    import api from '../../../api'
    import { mapGetters, mapActions } from 'vuex'
    import _ from 'lodash'
    import _system from '../../../libs/system'	

    import { removeChannel } from '../mixins/removeChannel'

	export default 
	{
        name: 'accountsTwitter',
        mixins: [removeChannel],
        data() 
        {
        	return {
                config: config,
                twitterQuery: false,
                pages: [],
                loader: true,
                newChannelName: ''
        	}
        },
        computed: 
	    {
	        ...mapGetters('session', ['isLoggedIn','getUser','getRole','getJwt']),
            ...mapGetters('accounts', ['accounts', 'accountsById']),
            ...mapGetters('tags', ['tagsByName']),
            ...mapGetters('workspaces', ['currentWorkspace']),
            ...mapGetters('workspaceusers', ['workspaceusers']),
	        ...mapGetters('networks', ['networks','networksByName'])
        },
        methods: {
            ...mapActions('accounts', ['setAccounts', 'removeChannel']),
            ...mapActions('networks', ['setNetworks']),
            reAuth(){
               document.getElementById("auth").submit(); 
            },
            update_status(e, pageId){
                if(!e.target.checked) {
                    let payload = {
                        query: {
                            pageId: pageId
                        },
                        body: {
                            tagId: this.tagsByName['Passive']._id
                        }
                    }
                    _system.services.accounts.setTag(payload, (err, updatedChannel) => {
                        this.accounts[_.findIndex(this.accounts, { _id: pageId })] = updatedChannel
                    });                   
                }else{
                    console.log('aga')
                    let payload = {
                        query: {
                            pageId: pageId,
                            tagId: this.tagsByName['Passive']._id
                        }
                    }
                    _system.services.accounts.deleteTag(payload, (err, updatedChannel) => {
                        this.accounts[_.findIndex(this.accounts, { _id: pageId })] = updatedChannel
                    });
                }

            },
            removePageFromWorkspaceUser(channel){
            //let workspaceUser = _.find(this.workspaceusers, { user: { _id: this.getUser._id }})


        let getAdminsAccounts = _.filter(this.workspaceusers, (workspaceuser) => {
            if(workspaceuser.tags.includes(this.tagsByName['Admin']._id)) return workspaceuser
        });



        for (const workspaceUser of getAdminsAccounts) {

            let payload = {
                query: {
                    workspaceuserId: workspaceUser._id,
                    pageId: channel._id
                }
            }

            _system.services.workspaceusers.deleteAccount(payload, (err, workspaceUsers) => {
                if(err) alert(err.message);


                if(workspaceUsers.user == this.getUser._id){
                    let i = _.findIndex(this.accounts, { _id: channel._id })
                    
                    this.accounts.splice(i, 1);

                    this.pages = _.filter(workspaceUsers.pages, (e) => { return (e.platform == this.networksByName['Twitter']._id || e.parent && e.parent.platform == this.networksByName['Twitter']._id) }); 
                }

            });

            }

            },
            createChannelForListening(channel){

                let workspaceUser = _.find(this.workspaceusers, { user: { _id: this.getUser._id }})

                let payload = {
                    body: {
                        "id": Math.floor(Date.now() + Math.random()).toString(), 
                        "name": channel.keyword.trim(), 
                        "avatar": channel.avatar,
                        "platform": this.networksByName['Twitter']._id,
                        "tags": ['5d1e2f9d3ca62990fe439655'],
                        "parent": {
                            "_id": channel._id
                        }
                    }
                }

                _system.services.accounts.create(payload, (err, newAccount) => {
                    if (err) return alert(err.message);



                        let getAdminsAccounts = _.filter(this.workspaceusers, (workspaceuser) => {
                            if(workspaceuser.tags.includes(this.tagsByName['Admin']._id)) return workspaceuser
                        });



                    for (const user of getAdminsAccounts) {
                        //console.log('##aggario', user);
                        let payload = {
                            query:{
                                "userId": user._id
                            },
                            body: {
                                "pageId": newAccount._id
                            }
                        }

                        _system.services.workspaceusers.addAccount(payload, (err, workspaceUsers) => {
                            if(err) return alert(err.message);

                            channel.keyword = ''

                            if(workspaceUsers.user == this.getUser._id){
                            this.accounts.push(newAccount);

                            this.pages = _.filter(workspaceUsers.pages, (e) => { return (e.platform == this.networksByName['Twitter']._id || e.parent && e.parent.platform == this.networksByName['Twitter']._id) }); 
                            }

                        });
                    }


                });

            }
        },
        mounted(){
            $('.ui.dropdown').dropdown({
                transition: 'scale'
            })


            
            if(this.$route.query.twitter){
                this.twitterQuery = true;
            }
            
        },
        created(){
            //Store Fetching
            if(this.accounts && this.networks){
                this.pages = _.filter(this.accounts, (e) => { return (e.platform == this.networksByName['Twitter']._id || e.parent && e.parent.platform == this.networksByName['Twitter']._id) }); 
                this.loader = false;
            }  

        }
	}
</script>

<template>
	<span>

        <div style="background: #f5f5f5;" class="ui grid">
        <div class="six wide column">
            <form style="margin: 0;" class="ui form" v-if="getRole.name == 'Admin' && twitterQuery" id="auth" :action=" config.url + '/twitter/auth'" method="post">
                <input type="text" name="accessToken" v-model="getJwt" hidden>
                <input type="text" name="workspaceId" v-model="currentWorkspace._id" hidden>
                <button id="TwitterAddButton" type="submit" value="Submit" class="ui twitter button"><i class="icon twitter"></i> Add Twitter Account </button>
            </form>
        </div>
        <div style="text-align: right;" class="ten wide column">
        </div>
        </div>

        <div v-if="!loader && !pages.length" class="ui basic padded segment center aligned">
            <p style="color: #ccc;font-size: 20px;">
                Don't have any active Twitter Account
            </p>
        </div>

        <table v-if="!loader && pages.length" style="padding: 0rem 0.5rem;" class="ui very basic celled table fluid">
            <tbody>
            
            <tr v-for="account in pages" :key="account._id">
               
                <td>
                <h4 class="ui image header">
                    <img :src="account.avatar" class="ui mini rounded image">
                    <div class="content">
                        {{account.name}}
                    </div>
                </h4>
                
                </td>
                <td class="collapsing" :style="(account.tags && account.tags.indexOf('5e8e0527817d3903cb610bde') != -1) ? 'white-space: normal;' : 'vertical-align: bottom; text-align: right;'">

            <div v-if="(account.tags && account.tags.indexOf('5e8e0527817d3903cb610bde') != -1  && !account.parent)" class="ui compact warning small message" style="width:400px;">
                        <div class="header">Permissions Expired</div>
                        <p>Juphy can't access data for this channel. To regain data access, you have to re-authorize your account's permissions. 
                            <a :href="'#'" @click="reAuth()">Click here to re-authorize</a>
                        </p>
                    </div>

            <div v-if="getRole.name == 'Admin' && !account.parent && (account.tags && account.tags.indexOf('5e8e0527817d3903cb610bde') == -1) || (!account.tags)" style="margin-right: 20px;" class="ui action mini input">
            <input style=" min-width: 200px;" v-model="account.keyword" v-on:keyup.enter="createChannelForListening(account)" type="text" placeholder="Add Keyword for Streaming">
            <a @click="createChannelForListening(account)" class="ui mini icon button">Save</a>
            </div>

            <button v-if="getRole.name == 'Admin' && account.parent" @click="removePageFromWorkspaceUser(account)" class="ui mini button">Remove</button>

<!--                     <div v-if="getRole.name == 'Admin' && !account.parent && (account.tags && account.tags.indexOf('5e8e0527817d3903cb610bde') == -1) || (!account.tags)" style="vertical-align: sub;"  class="ui fitted toggle checkbox check">
                        
                        <input v-if="account.tags && account.tags.indexOf(tagsByName['Passive']._id) != -1"  @click="update_status($event, account._id)" type="checkbox" :checked="false">
                        <input v-if="!account.tags || account.tags.indexOf(tagsByName['Passive']._id) == -1" @click="update_status($event, account._id)" type="checkbox" :checked="true"> 
                        <label></label>
                        
                    </div> -->

                </td>
                <td  class="collapsing">
                <div v-if="getRole.name == 'Admin' && !account.parent || (!account.tags)" style="background: transparent;" class="ui left dropdown icon button">
                    <i class="ellipsis vertical icon"></i>
                    <div class="menu">
                        <div @click="deleteChannel(account._id)" class="item">
                        Delete
                        </div>
                    </div>
                    </div>
                </td>
<!--                               <td class="collapsing">
                    <a :href="'/account/settings/'+ account.id" class="ui basic small icon button more-basic"><i class="cog icon"></i></a>
                </td> -->
            </tr>
            
            </tbody>
        </table> 
<!--         <form v-if="pages.length && getRole.name == 'Admin'" :action=" config.url + '/twitter/auth'" method="post">
        <input type="text" name="accessToken" v-model="getJwt" hidden>
                <input type="text" name="workspaceId" v-model="currentWorkspace._id" hidden>
        <button type="submit" value="Submit" class="ui twitter button right floated"><i class="icon twitter"></i> Add Twitter Account </button>
        </form> -->
	</span>
</template>


<style scoped >
.ui.table thead th {
    border-bottom: none;
}
.ui.toggle.checkbox input:checked ~ label::before {
    background-color: #8ef2b6 !important;
}
.ui.toggle.checkbox label::before{
    height: 1.9rem;
}
.ui.toggle.checkbox label::after{
    height: 1.9rem;
    width: 1.9rem;
}
.ui.toggle.checkbox input:checked ~ label::after {
    left: 1.6rem;
    box-shadow: 1px 1px 1px #ddd;
}
.ui.toggle.checkbox input {
    height: 1.9rem;
}

</style>



// WEBPACK FOOTER //
// src/components/dashboard/accounts/twitter.vue